module.exports = __webpack_public_path__ + "../../static/vue/img/running.36ea81b1.gif";